<template>
	<div class="CarDetails">
		<div class="row justify-content-center height50">
			<div class="col-md-6">
				<div class="sum-item">
					<div class="row">
						<div class="col-12">
							<p class="sum-label">{{ $t('Station') }}</p>
						</div>
					</div>
					<div class="row station-content">
						<div class="col-auto align-self-start station-icon">
							<div class="icn icn-card icn-location_dot"></div>
						</div>
						<div class="col align-self-center">
							<h4 class="sum-text text-left">{{ resStation.name }} - {{ resStation.city }},<br>{{ resStation.street }}</h4>
						</div>
						<div class="col-auto align-self-center">
							<router-link :to="{name: 'PagePlace'}">{{ $t('Change') }}</router-link>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="sum-item">
					<div class="row">
						<div class="col-12">
							<p class="sum-label">{{ $t('Car') }}</p>
						</div>
					</div>
					<div class="row align-items-center car-content no-gutters">
						<div class="col-auto">
							<h4 class="sum-text">{{ car.app_description || car.title_web }}</h4>
						</div>
						<div class="col text-center">
							<img class="img-responsive"
							:src="(car.download ? car.download : '/static/img/car-dummy.png')" />
						</div>
						<div class="col-auto">
							<router-link :to="{name: 'PageCar'}">{{ $t('Change') }}</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row justify-content-center height50">
			<div class="col-md-6">
				<div class="sum-item">
					<div class="row">
						<div class="col-12">
							<p class="sum-label">{{ $t('Period') }}</p>
						</div>
					</div>
					<div class="row time-content">
						<div class="col-auto align-self-start time-icon">
							<div class="icn icn-card icn-timer"></div>
						</div>
						<div class="col align-self-center">
							<h4 class="sum-text text-left" v-html="formatter.OUTPUT_DATE_RANGE(resStartdate, resEnddate)"></h4>
						</div>
						<div class="col-auto align-self-center">
							<router-link :to="{name: 'PageTime'}">{{ $t('Change') }}</router-link>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="sum-item">
					<div class="row">
						<div class="col-12">
							<p class="sum-label">{{ $t('Price') }}</p>
						</div>
					</div>
					<div class="row price-content">
						<div class="col-auto align-self-Start">
							<p class="sum-price">{{ formatter.OUTPUT_PRICE(price) }} €</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import { mapGetters } from 'vuex'
import formatter 		from '@/store/orm/helpers/formater';

export default {
	name: "CarDetails",
	computed: {

		car(){
			var self = this;
			if(this.group) {
				return this.group;
			} else if(this.groupKey){
				return this.$store.getters["orm/group"](this.groupKey);
			}
			return {}
		},

	    ...mapGetters('orm/reservation', {
	    	resStation: 'station',
			resStartdate: 'startdate',
			resEnddate: 'enddate',
			resNavigation: 'navigation',
	    }),
	},
	props: {
		groupKey: {
			type: String,
		},
		group: {
			type: Object,
		},
		price: {
			type: Number,
			default: 0
		}
	},
	data(){
		return {
			formatter
		};
	},
}
</script>



// WEBPACK FOOTER //
// src/components/Modules/CarDetails.vue